// Create and setup your form here
 
<template>

    <header class="vff-header">
      <div class="f-container">
        <div class="logo"></div>
      </div>
    </header>

    <div v-bind:class="classObject">
      <div class="header_content">
        <div class="pageslogan">Klare Antworten<br>
          auf komplexe Fragen</div>
      </div>
    </div>

    <flow-form
      ref="flowform"
      v-on:complete="onComplete"
      v-on:submit="onSubmit"
      v-bind:questions="questions"
      v-bind:language="language"
      v-bind:standalone="true"
    >
    <!-- Custom content for the Complete/Submit screen slots in the FlowForm component -->
      <!-- We've overriden the default "complete" slot content -->
     <template v-slot:complete>
        <div class="f-section-wrap">
          <p>
            <span class="fh2">Wir möchten Sie kennenlernen</span>
            <span class="f-section-text">
              Drücken Sie auf {{ language.submitText }} um Ihre persönlichen Daten einzugeben.
            </span>
          </p>
          <p class="f-description">Notiz: Ihre Angaben werden für Ihren Bewerbungsprozess gespeichert.</p>
        </div>  
      </template>

      <!-- We've overriden the default "completeButton" slot content -->
      <template v-slot:completeButton>
        <div class="f-submit" v-if="!submitted">
          <button 
            class="o-btn-action"
            ref="button"
            type="submit"
            href="#"
            v-on:click.prevent="onSendData()"
            aria-label="Press to submit"
          >
            <span>{{ language.submitText }}</span>
          </button>
          <a class="f-enter-desc"
            href="#"
            v-on:click.prevent="onSendData()"
            v-html="language.formatString(language.pressEnter)">
          </a>
        </div>

        <p class="text-success" v-if="submitted">Daten gespeichert</p>
      </template>
    </flow-form>

</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://www.ditdot.hr/en
  */

  // Import necessary components and classes
  import FlowForm from '../../src/components/FlowForm.vue'
  import QuestionModel, { QuestionType, ChoiceOption, LinkOption } from '../../src/models/QuestionModel'
  import LanguageModel from '../../src/models/LanguageModel'
  // If using the npm package, use the following line instead of the ones above.
  // import FlowForm, { QuestionModel, QuestionType, ChoiceOption, LanguageModel } from '@ditdot-dev/vue-flow-form'

  export default {
    name: 'jobform',

    components: {
      FlowForm
    },

    data() {
      return {
        submitted: false,
        completed: false,
        language: new LanguageModel({
          enterKey : 'Eingabe',
          shiftKey : 'Shift',
          ok : 'OK',
          continue : 'Weiter',
          skip : 'Überspringen',
          pressEnter : 'Drücken Sie die :enterKey Taste',
          multipleChoiceHelpText : 'Mehrfachauswahl möglich',
          multipleChoiceHelpTextSingle : 'Einfachauswahl',
          otherPrompt: "Andere",
          placeholder : 'Schreiben Sie Ihre Antwort hier...',
          submitText : 'Weiter',
          longTextHelpText : ':Shift Taste + :enterKey für Zeilenumbrüche.',
          prev : 'Vorherige',
          next : 'Nächste',
          percentCompleted : ':percent% Komplett',
          invalidPrompt : 'Bitte füllen Sie das Formular richtig aus',
          thankYouText : 'Danke sehr!',
          successText : 'Ihre Anfrage wurde versendet.',
          ariaOk : 'Drücken Sie auf Weiter',
          ariaRequired : 'Dieser Schritt ist erforderlich',
          ariaPrev : 'Vorheriger Schritt',
          ariaNext : 'Nächster Schritt',
          ariaSubmitText : 'Drücken Sie Absenden',
          ariaMultipleChoice : 'Drücken Sie einen :letter zur Auswahl',
          ariaTypeAnswer : 'Schreiben Sie Ihre Antwort',
          errorAllowedFileTypes : 'Falscher Dateityp. Erlaubte Dateitypen sind: :fileTypes.',
          errorMaxFileSize : 'Datei/en zu groß. Maximale Dateigröße: :size.',
          errorMinFiles : 'Zu wenig Dateien. Mindestsdateimenge: :min.',
          errorMaxFiles : 'Zu viele Dateien. Maximaldateimenge: :max.'
        }),
        // Create question list with QuestionModel instances
        questions: [
          new QuestionModel({
            id: 's1',
            title: 'Welchen Beruf üben Sie aktuell aus?',
            content: '',
            helpTextShow: true,
            type: QuestionType.MultipleChoice,
            multiple: true,
            allowOther: true,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Steuerfachangestellte/r',
              }),
              new ChoiceOption({
                label: 'Steuerfachwirt/in',
              })
            ]
          }),

          new QuestionModel({
            id: 's2',
            tagline: '',
            title: 'Wie lange sind Sie in diesem Beruf tätig?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            allowOther: false,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Weniger als 2 Jahre'
              }),
              new ChoiceOption({
                label: '2-4 Jahre'
              }),
              new ChoiceOption({
                label: '4-8 Jahre'
              }),
              new ChoiceOption({
                label: 'Mehr als 8 Jahre'
              })
            ]
          }),

          new QuestionModel({
            id: 's3',
            tagline: '',
            title: 'Wie schätzen Sie Ihre DATEV-Kenntnisse ein?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            allowOther: false,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Sehr gut',
                value: 'Sehr gut'
              }),
              new ChoiceOption({
                label: 'Gut',
                value: 'Gut'
              }),
              new ChoiceOption({
                label: 'Ich komme zurecht',
                value: 'Ich komme zurecht',
              }),
              new ChoiceOption({
                label: 'Keine Kenntnisse',
                value: 'Keine Kenntnisse'
              }),
            ]
          }),
          new QuestionModel({
            id: 's4',
            tagline: '',
            title: 'Wie schätzen Sie Ihre IT-Affinität ein?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            allowOther: false,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Sehr gut',
                value: 'Sehr gut'
              }),
              new ChoiceOption({
                label: 'Gut',
                value: 'Gut'
              }),
              new ChoiceOption({
                label: 'Ich komme zurecht',
                value: 'Ich komme zurecht',
              }),
              new ChoiceOption({
                label: 'Geringer',
                value: 'Geringer'
              }),
            ]
          }),

          new QuestionModel({
            id: 'gehalt',
            tagline: '',
            title: 'Wie zufrieden sind Sie mit Ihrem aktuellen Gehalt?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            allowOther: false,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Sehr zufrieden'
              }),
              new ChoiceOption({
                label: 'Zufrieden'
              }),
              new ChoiceOption({
                label: 'Eher unzufrieden'
              }),
              new ChoiceOption({
                label: 'Sehr unzufrieden'
              }),
            ]
          }),
          new QuestionModel({
            id: 'anfangen',
            tagline: '',
            title: 'Wann können Sie bei uns anfangen?',
            helpTextShow: false,
            type: QuestionType.MultipleChoice,
            multiple: false,
            allowOther: false,
            required: true,
            options: [
              new ChoiceOption({
                label: 'Sofort'
              }),
              new ChoiceOption({
                label: 'in 2 - 4 Wochen'
              }),
              new ChoiceOption({
                label: 'in 4 - 8 Wochen'
              }),
              new ChoiceOption({
                label: 'Später als 8 Wochen'
              }),
            ],
            jump: {
              _other: '_submit'
            }
          })
        ]
      }
    },

    mounted() {
      document.addEventListener('keyup', this.onKeyListener)
      window.localStorage.setItem('flowform', 'false')

      // document.addEventListener('step', this.onStep)
      // this.$emit('step', this.onStep)
      // this.$el.addEventListener('step', this.onStep)
      // this.$refs.flowform.step

    },

    computed: {
      classObject: function () {
        let images = [
          'header_01',
          'header_02',
          'header_03',
          'header_04',
          'header_05',
          'header_06',
          'header_07'
        ];
        let myImg = images[Math.floor(Math.random() * images.length)];
        return "headerImg " + myImg
      }
    },

    beforeUnmount() {
      document.removeEventListener('keyup', this.onKeyListener)
    },

    methods: {
      // onStep(activeQuestionId, activeQuestion) {
      //   console.log( activeQuestionId, activeQuestion )
      //   alert('onStep')
      // },

      onKeyListener($event) {
        // We've overriden the default "complete" slot so
        // we need to implement the "keyup" listener manually.

        console.log( "$event", $event )

        if ($event.key === 'Enter' && this.completed && !this.submitted) {
          this.onSendData()
        }
      },

      /* eslint-disable-next-line no-unused-vars */
      onComplete(completed, questionList) {
        // This method is called whenever the "completed" status is changed.
        this.completed = completed
      },

      /* eslint-disable-next-line no-unused-vars */
      onSubmit(questionList) {
        // This method will only be called if you don't override the
        // completeButton slot.
        this.onSendData()
      },
      
      onSendData() {
        // Set `submitted` to true so the form knows not to allow back/forward
        // navigation anymore.
        this.$refs.flowform.submitted = true

        this.submitted = true

        /* eslint-disable-next-line no-unused-vars */
        const data = this.getData()

        window.localStorage.setItem('flowform', JSON.stringify(data))
        const url = "../jobform.php?flowform=true"
        document.location.href = url

        /*
          You can use Fetch API to send the data to your server, eg.:
        const url = "./form.php"
          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
        */
      },

      getData() {
        const data = {
          questions: [],
          answers: []
        }

        this.questions.forEach(question => {
          if (question.title) {
            let answer = question.answer
            if (Array.isArray(answer)) {
              answer = answer.join(', ')
            }

            data.questions.push(question.title)
            data.answers.push(answer)
          }
        })

        return data
      }
    }
  }
</script>

<style lang="css">
  @import '../../src/assets/css/themes/theme-minimal.css';
  @import './assets/css/main.css';
  /* If using the npm package, use the following lines instead of the one above */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css'; */
  /* @import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css'; */
</style>